import styled from "styled-components";
import {Dropdown} from "react-bootstrap";

export const HeaderMenuItemBody = styled.div`
  display: flex;
  align-self: center;
  margin: 0;
`
export const HeaderMenuItemImg = styled.img`
  max-width: 20px;
  max-height: 20px;
  margin-right: 5px;
`
export const HeaderMenuItemDiv = styled.div`
  display: flex;
  align-items: center;
`
export const HeaderMenuItemText = styled.p`
  margin: 0;
  align-self: center;
`

export const DropdownToggle = styled(Dropdown.Toggle)`
    background: transparent !important;
  border: none;
  color: black !important;
  display: flex;
  //
  //justify-self: center;
  //justify-content: center;
  align-self: center;
  
  
  &:hover {
    background: transparent;
    border: none;
    color: blue;
  }

  &:active{
    background: transparent !important;
    border: none;
    color: blue !important;
  }
`

export const DropdownMenu = styled(Dropdown)`
  display: flex;
  justify-content: center;

  @media (max-width: 760px) {
    justify-content: end;  
  }

  button {
    &:after {
      content: none;
    }
  }
`

export const DropdownItem = styled.div`
display: none;
  @media (max-width: 760px) {
    display: block;
  }
  
`
